<list-view *ngIf="accueilService.listeAccueilView" [liste]="accueilService.listeAccueilView" [hover]="false"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>
